export function getDistanceBetweenTwoGeographicalCoordinates(
  lat1?: number | null,
  lon1?: number | null,
  lat2?: number | null,
  lon2?: number | null,
) {
  if (!lat1 || !lon1 || !lat2 || !lon2) {
    return undefined;
  }

  const R = 6371; // Radius of the Earth in kilometers

  // Convert degrees to radians
  const lat1Rad = degToRad(lat1);
  const lon1Rad = degToRad(lon1);
  const lat2Rad = degToRad(lat2);
  const lon2Rad = degToRad(lon2);

  // Apply the formula
  const distance =
    Math.acos(
      Math.sin(lat1Rad) * Math.sin(lat2Rad) +
        Math.cos(lat1Rad) * Math.cos(lat2Rad) * Math.cos(lon2Rad - lon1Rad),
    ) * R;

  return distance.toFixed(1);
}

function degToRad(degrees: number) {
  return degrees * (Math.PI / 180);
}
